/** §2.4.1 — compare public report date with local last-read date */
export function isDailyMarketUnread(
  reportDate: string | null | undefined,
  lastReadDate: string | null,
): boolean {
  if (!reportDate) {
    return false;
  }
  return lastReadDate !== reportDate;
}
